// REAL image class
real.image = {};
